import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const PinSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.30711 13.9218C7.54132 16.8444 9.21199 19.2655 10.8152 21.5559H5.88996C5.51125 21.5559 5.20425 21.8629 5.20425 22.2416C5.20425 22.6203 5.51125 22.9273 5.88996 22.9273H18.2328C18.6115 22.9273 18.9185 22.6203 18.9185 22.2416C18.9185 21.8629 18.6115 21.5559 18.2328 21.5559H13.3044C14.8674 19.2655 16.4255 16.8444 17.7022 13.9218C18.3841 12.335 19.2814 10.225 19.2814 7.92318C19.2814 3.80783 16.3743 1.07007 11.9957 1.07007C7.61711 1.07007 4.71 3.80783 4.71 7.92318C4.71 10.2056 5.60985 12.2994 6.2898 13.8816L6.30711 13.9218ZM16.4439 13.3766C17.1363 11.7652 17.91 9.90261 17.91 7.92318C17.91 6.20211 17.3105 4.86465 16.3407 3.95216C15.3633 3.0325 13.8985 2.4415 11.9957 2.4415C10.0929 2.4415 8.62806 3.0325 7.65068 3.95216C6.68092 4.86465 6.08143 6.20211 6.08143 7.92318C6.08143 9.90015 6.86996 11.758 7.56713 13.3804L7.57052 13.3883L7.57049 13.3883C8.77458 16.2395 10.415 18.5925 12.0612 20.9442C13.6496 18.6228 15.1897 16.2463 16.4439 13.3766ZM14.1188 8.35582C14.1188 9.49195 13.1978 10.413 12.0617 10.413C10.9255 10.413 10.0045 9.49195 10.0045 8.35582C10.0045 7.21969 10.9255 6.29867 12.0617 6.29867C13.1978 6.29867 14.1188 7.21969 14.1188 8.35582ZM15.4902 8.35582C15.4902 10.2494 13.9552 11.7844 12.0617 11.7844C10.1681 11.7844 8.63309 10.2494 8.63309 8.35582C8.63309 6.46227 10.1681 4.92725 12.0617 4.92725C13.9552 4.92725 15.4902 6.46227 15.4902 8.35582Z"
        fill={color}
      />
    </svg>
  );
};

export { PinSvg };
